import React, {Component} from "react";
import {connect} from "react-redux";
import Recommendation from '@bit/codeorangex.minerva-ui.ui.recommendation';
import Filters from "../Filters";
import * as recommendationsActions from "../../../../actions/recommendationsActions";
import * as reissueActions from "../../../../actions/reissueActions";

class Recommendations extends Component {

    render() {
        const { recommendations } = this.props;
        return (
            <div className="">
                {recommendations && recommendations.length ? <Filters /> : null}
                <div className="SearchRecommendationsResult" style={{"padding-bottom": "116px;"}}>
                    {
                        recommendations.map((recommendation,i) => {
                            return (
                                <div className="Recommendation" key={i}>
                                    <div className="alert alert-primary row ml-0 mr-0 mb-0" role="alert">
                                        {recommendation.itinerary.map((option, index) => {
                                            return(
                                                <div className="col" key={index}>
                                                    Tarifa Tramo {index + 1} :
                                                    <span style={{fontWeight: "bold"}}>
                                                        {option.flights[0].brandedFare.description}
                                                    </span>
                                                </div>
                                            )
                                        })}
                                    </div>
                                    <Recommendation {...recommendation}
                                                    onChangeFlights={flights => console.log(flights)}
                                                    onContinue={() => {
                                                        this.props.resetReissue();
                                                        this.props.history.push(`/recommendations/${recommendation.offerId.offerId}/${recommendation.shoppingResponseRefID.shoppingResponseRefID}`);
                                                    }} />
                                </div>

                            )
                        })
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({recommendationsReducer}) => recommendationsReducer;

export default connect(
    mapStateToProps,
    {
        ...recommendationsActions,
        ...reissueActions
    }
)(Recommendations);
